import { timezoneForSquad, wallClockInZone } from "./signupTimezone";

export const SQUAD_SESSION = {
  upcoming: "upcoming",
  bowling: "bowling",
  complete: "complete",
};

export const SQUAD_BOWLING_HOURS = 3;

export const squadSessionStatus = (squad, now = new Date()) => {
  if (!squad?.squadDate) return null;
  const start = wallClockInZone(
    squad.squadDate,
    squad.squadTime,
    timezoneForSquad(squad)
  );
  if (!start) return null;
  const hasTime = Boolean(squad?.squadTime);
  const durationHours = hasTime ? SQUAD_BOWLING_HOURS : 24;
  const end = new Date(start.getTime() + durationHours * 60 * 60 * 1000);
  if (now < start) return SQUAD_SESSION.upcoming;
  if (now < end) return SQUAD_SESSION.bowling;
  return SQUAD_SESSION.complete;
};

export const squadSessionStatusLabel = (status) => {
  if (status === SQUAD_SESSION.bowling) return "Bowling";
  if (status === SQUAD_SESSION.upcoming) return "Upcoming";
  if (status === SQUAD_SESSION.complete) return "Complete";
  return null;
};

export const squadSessionLiveLabel = (status) =>
  status === SQUAD_SESSION.bowling ? "Bowling" : "";
